<template lang="html">
  <flickity ref="flickity"
  :options="flickityOptions" class="collection-slider-main" aria-label="Product Collection Slider" role="group">
    <template v-for="(product) in products">
      <div class="carousel-cell" :key="product.id">
        <ProductCard
        :key="productKey"
        @refresh-product="refreshProductCard"
        :inSlider="true"
        :data="JSON.stringify(product.productData)" 
        :quickviewData="JSON.stringify(product.quickview)" 
        v-on:sliderQuickview="sendDataToSliderModal
        "/>
      </div>
    </template>
  </flickity>
</template>

<script>
  import Flickity from 'vue-flickity';
  import ProductCard from 'scripts/components/product/ProductCard.vue';

  export default {
    name: 'CollectionSlider',
    components: {
      Flickity,
      ProductCard
    },
    props: {
      data: {
        type: String,
        required: true
      }
    },
    computed: {
      collectionData() {
        return JSON.parse(this.data);
      },
      products() {
        return this.collectionData.products;
      }
    },
    methods: {
      sendDataToSliderModal(data) {
        this.$emit('sendToModal', data)
      },
      pushViewItemListEvent() {
        const items = this.collectionData.products.map((product, index) => ({
          item_name: product.productData.product.title.replace('\"', ''), 
          item_id: product.productData.product.variants[0].sku, 
          price: (product.productData.product.variants[0].price / 100.00), 
          item_brand: product.productData.product.vendor, 
          item_list_id: 'feature-products', 
          item_list_name: 'Feature products', 
          quantity: 1,
          item_variant: product.productData.product.variants[0].title,
          item_category: product.productData.productCollections ? product.productData.productCollections[0].title : "",
          index: index + 1, // Position in the list 
        }));

        // Push the view_item_list event to the DataLayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "view_item_list",
          ecommerce: {
            items: items
          }
        });
      }
    },
    data() {
      return {
        flickityOptions: {
          cellAlign: 'left',
          contain: true,
          pageDots: true,
          draggable: true,
          resize: true,
          groupCells: '100%',
          adaptiveHeight: false,
          prevNextButtons: true,
          imagesLoaded: true,
          setGallerySize: false,
          wrapAround: true
        }
      }
    },
    mounted() {
      // Trigger the view_item_list event 
      let scopedThis = this;
      setTimeout(function(){
        scopedThis.pushViewItemListEvent();
      },3e3);  
    }
  }
</script>

<style lang="scss" scoped></style>
